import { render } from "./AdvertisingPolicy.vue?vue&type=template&id=7a1d923f&scoped=true"
import script from "./AdvertisingPolicy.vue?vue&type=script&lang=js"
export * from "./AdvertisingPolicy.vue?vue&type=script&lang=js"

import "./AdvertisingPolicy.vue?vue&type=style&index=0&id=7a1d923f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a1d923f"]])

export default __exports__